// Utility function to convert Google Drive sharing links to direct video links
export const convertGoogleDriveLink = (url) => {
  if (!url || typeof url !== 'string') {
    return url;
  }

  // Check if it's a Google Drive sharing link
  const driveRegex = /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/;
  const match = url.match(driveRegex);
  
  if (match && match[1]) {
    const fileId = match[1];
    
    // Try multiple Google Drive direct link formats
    // Format 1: Direct streaming (most likely to work for public files)
    return `https://drive.google.com/uc?export=view&id=${fileId}`;
    
    // Alternative formats you can try:
    // Format 2: Download format
    // return `https://drive.google.com/uc?export=download&id=${fileId}`;
    
    // Format 3: Simple format
    // return `https://drive.google.com/uc?id=${fileId}`;
    
    // Format 4: Embed format (for iframe, not direct video)
    // return `https://drive.google.com/file/d/${fileId}/preview`;
  }
  
  // Return original URL if it's not a Google Drive link
  return url;
};

// Helper function to validate video URL and provide fallback
export const validateVideoUrl = (url) => {
  if (!url) return null;
  
  // Check if it's a Google Drive link
  if (url.includes('drive.google.com')) {
    console.warn('Google Drive videos may not play directly. Consider using a proper video CDN like Cloudflare Stream, Vimeo, or AWS S3.');
    return convertGoogleDriveLink(url);
  }
  
  // Check if it's a direct video file
  const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov', '.avi'];
  const hasVideoExtension = videoExtensions.some(ext => url.toLowerCase().includes(ext));
  
  if (!hasVideoExtension && !url.includes('stream') && !url.includes('video')) {
    console.warn('URL may not be a direct video link:', url);
  }
  
  return url;
};

// Helper function to process video data and convert Google Drive links
export const processVideoData = (videos) => {
  if (!Array.isArray(videos)) {
    return [];
  }

  return videos.map((video, index) => {
    const processedLink = validateVideoUrl(video.link);
    
    if (!processedLink) {
      console.error(`Video ${index + 1} (${video.name}) has invalid URL:`, video.link);
    }
    
    return {
      ...video,
      link: processedLink,
      // Add originalLink for debugging
      originalLink: video.link
    };
  });
};

// Create iframe embed URL for Google Drive videos (fallback option)
export const createGoogleDriveEmbedUrl = (url) => {
  const driveRegex = /https:\/\/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/;
  const match = url.match(driveRegex);
  
  if (match && match[1]) {
    return `https://drive.google.com/file/d/${match[1]}/preview`;
  }
  
  return url;
};

// Alternative video URLs for testing (replace your Google Drive links with these)
export const getTestVideoUrls = () => {
  return [
    {
      name: "Sample Video 1",
      link: "https://sample-videos.com/zip/10/mp4/SampleVideo_1280x720_1mb.mp4",
      thumbnail: "https://via.placeholder.com/300x200/FFA525/FFFFFF?text=Video+1"
    },
    {
      name: "Sample Video 2", 
      link: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
      thumbnail: "https://via.placeholder.com/300x200/FFA525/FFFFFF?text=Video+2"
    }
  ];
};